var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { inject, injectable } from '@serviceos-rn/core';
import { ITipPayloadRepositoryType } from '../ITipPayloadRepository';
import { ITipRepositoryType } from '../ITipRepository';
import { ITipAnalyticsEventsRepositoryType } from '../ITipAnalyticsEventsRepository';
import { IGetAnalyticEventParamsUseCaseType } from '../GetAnalyticEventParamsUseCase/IGetAnalyticEventParamsUseCase';
import { ICoordinatorServiceType } from '../../../Services/CoordinatorService/ICoordinatorService';
let AddTipUseCase = class AddTipUseCase {
    constructor(repository, coordinatorService, payloadRepository, analyticsRepository, getSelectedChoiceItem) {
        this.repository = repository;
        this.coordinatorService = coordinatorService;
        this.payloadRepository = payloadRepository;
        this.analyticsRepository = analyticsRepository;
        this.getSelectedChoiceItem = getSelectedChoiceItem;
    }
    execute() {
        const tip = Object.assign(Object.assign({}, this.repository.tip.value), { customize: Object.assign(Object.assign({}, this.repository.tip.value.customize), { tipped: false }), choice_items: this.repository.tip.value.choice_items || [] });
        this.repository.setTip(tip);
        const { booking_transaction_id, position, booking_id } = this.getSelectedChoiceItem.execute(tip.choice_items);
        this.analyticsRepository.sendAddAnotherTipButtonTappedEvent({ booking_transaction_id, position, booking_id });
        return this.coordinatorService.navigateToTip(this.payloadRepository.getMode().value);
    }
};
AddTipUseCase = __decorate([
    injectable(),
    __param(0, inject(ITipRepositoryType)),
    __param(1, inject(ICoordinatorServiceType)),
    __param(2, inject(ITipPayloadRepositoryType)),
    __param(3, inject(ITipAnalyticsEventsRepositoryType)),
    __param(4, inject(IGetAnalyticEventParamsUseCaseType)),
    __metadata("design:paramtypes", [Object, Object, Object, Object, Object])
], AddTipUseCase);
export { AddTipUseCase };
